import React from "react";
import { Link } from "react-router-dom";

const ErrorScreen = () => {
  return (
    <div className="hadacy-error">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600&family=Jost:wght@200;300;400;500&display=swap');
        .hadacy-error {
          --dark: #1a1410;
          --gold: #b8933a;
          --gold-light: #d4af6a;
          --muted: #7a6e62;
          font-family: "Jost", sans-serif;
          text-align: center;
          padding: 4rem 1.5rem;
          color: var(--muted);
        }
        .hadacy-error__code {
          font-family: "Cormorant Garamond", serif;
          font-size: 5rem;
          font-weight: 300;
          color: var(--gold);
          letter-spacing: 0.05em;
          margin: 0 0 0.5rem 0;
          line-height: 1;
        }
        .hadacy-error__title {
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          font-size: 1.7rem;
          color: var(--dark);
          margin: 0 0 0.7rem 0;
        }
        .hadacy-error__lead {
          font-size: 0.95rem;
          margin: 0 0 1.6rem 0;
        }
        .hadacy-error__cta {
          display: inline-block;
          padding: 0.75rem 1.6rem;
          border-radius: 999px;
          background: var(--dark);
          color: var(--gold-light) !important;
          font-size: 0.7rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          text-decoration: none !important;
          transition: background .2s ease, color .2s ease;
        }
        .hadacy-error__cta:hover {
          background: var(--gold);
          color: var(--dark) !important;
        }
      `}</style>
      <h1 className="hadacy-error__code">404</h1>
      <h2 className="hadacy-error__title">¡Vaya! Parece que te perdiste.</h2>
      <p className="hadacy-error__lead">
        La página que buscas no existe o fue movida.
      </p>
      <Link to="/" className="hadacy-error__cta">
        Volver al inicio
      </Link>
    </div>
  );
};

export default ErrorScreen;
